import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import avator from "../../images/avatar.jpg";
import realAvatar from "../../images/real_avatar.jpg";
import "./Navbar.css";

// Constants
const SCROLL_THRESHOLD = 10;
const HIDE_THRESHOLD = 100;

function Navbar() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navigate = useNavigate();

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('featured-projects');
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToHome = () => {
    navigate("/");
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show navbar when at the top
      if (currentScrollY < SCROLL_THRESHOLD) {
        setIsVisible(true);
      } else {
        // Hide navbar when scrolling down, show when scrolling up
        if (currentScrollY > lastScrollY && currentScrollY > HIDE_THRESHOLD) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <div className={`my-navbar ${isVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
      <div className="my-logo" onClick={goToHome} style={{ cursor: 'pointer' }}>
        <div className="flip-container">
          <div className="flipper">
            <img src={realAvatar} alt="logo" className="back" />
            <img src={avator} alt="logo" className="front" />
          </div>
        </div>
      </div>
      <ul>
        <li onClick={scrollToProjects} style={{ cursor: 'pointer' }}>Projects</li>
        <li>About Me</li>
      </ul>
    </div>
  );
}

export default Navbar;
